import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-support-bulk-update-status-quick-action',
  templateUrl: './support-bulk-update-status-quick-action.component.html',
  styles: [
  ],
})
export class SupportBulkUpdateStatusQuickActionComponent implements OnInit {

  @Input() tickets: any[] = [];

  selectedTicketIds: string[] = [];

  bulkStatus: string = '';

  bulkStatusNote: string = '';

  ticketError = '';

  statusError = '';


  constructor(
    public activeModal: NgbActiveModal
  ) {}


  ngOnInit(): void {

  }


  /* =====================================================
     SELECT TICKET
     ===================================================== */

  toggleTicketSelection(
    ticketId: string,
    checked: boolean
  ): void {

    this.ticketError = '';

    if (checked) {

      if (
        this.selectedTicketIds.indexOf(ticketId) === -1
      ) {

        this.selectedTicketIds.push(ticketId);

      }

    } else {

      this.selectedTicketIds =
        this.selectedTicketIds.filter(
          id => id !== ticketId
        );

    }

  }


  /* =====================================================
     SELECT ALL
     ===================================================== */

  toggleSelectAll(
    checked: boolean
  ): void {

    this.ticketError = '';

    if (checked) {

      this.selectedTicketIds =
        this.tickets.map(
          ticket => ticket.ticketId
        );

    } else {

      this.selectedTicketIds = [];

    }

  }


  /* =====================================================
     CHECK SELECTED
     ===================================================== */

  isTicketSelected(
    ticketId: string
  ): boolean {

    return (
      this.selectedTicketIds.indexOf(
        ticketId
      ) !== -1
    );

  }


  /* =====================================================
     STATUS CHANGE
     ===================================================== */

  onStatusChange(): void {

    this.statusError = '';

  }


  /* =====================================================
     UPDATE
     ===================================================== */

  updateBulkStatus(): void {

    this.ticketError = '';

    this.statusError = '';


    if (
      this.selectedTicketIds.length === 0
    ) {

      this.ticketError =
        'Please select at least one ticket.';

      return;

    }


    if (!this.bulkStatus) {

      this.statusError =
        'Please select a status.';

      return;

    }


    this.activeModal.close({

      success: true,

      ticketIds:
        this.selectedTicketIds,

      status:
        this.bulkStatus,

      note:
        this.bulkStatusNote

    });

  }


  /* =====================================================
     CLOSE
     ===================================================== */

  close(): void {

    this.activeModal.dismiss();

  }

}